import * as React from 'react';

import { Route, Routes } from 'react-router-dom';

import { DeliveryAddressModal } from 'components/address-modal';
import { LazyRoute, lazyWithFallback } from 'components/layout/util';
import { NoStoresDeliveryModal } from 'components/modal-no-delivery-stores';
import { StoreStatus } from 'remote/api/restaurants';
import { relativeRoutes } from 'utils/routing';

const NoStoresOpenDeliveryModal: LazyRoute = lazyWithFallback(() =>
  import('components/modal-no-delivery-stores-open/no-stores-open-delivery-modal')
);

interface IDeliveryRoutesProps {
  deliveryModalPath?: string;
  dismissAddressModalUrl: string;
  redirectUrl: string;
}

export const DeliveryRoutes: React.VFC<IDeliveryRoutesProps> = ({
  deliveryModalPath = relativeRoutes.address,
  dismissAddressModalUrl,
  redirectUrl,
}) => {
  return (
    <Routes>
      <Route
        path={deliveryModalPath}
        element={
          <DeliveryAddressModal
            redirectUrl={redirectUrl}
            dismissAddressModalUrl={dismissAddressModalUrl}
          />
        }
      />

      <Route path={relativeRoutes[StoreStatus.NO_DELIVERY]} element={<NoStoresDeliveryModal />} />

      {/* May not be currently used, but should be no-harm to leave in. */}
      <Route path={relativeRoutes[StoreStatus.CLOSED]} element={<NoStoresOpenDeliveryModal />} />
    </Routes>
  );
};
